export default "__VITE_ASSET__DQ2FGomc__"